import React, { useMemo } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { getIsTimePeriodSelected } from './TimeFilter.helper';
import styles from './TimeFilter.module.scss';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
export const TimeFilter = ({ range, setRange }) => {
  const {
    isTodaySelected,
    isYesterdaySelected,
    isLastWeekSelected,
    isLastMonthSelected,
    isCustomDateRangeSelected,
  } = useMemo(() => {
    return getIsTimePeriodSelected(range);
  }, [range.start, range.end]);
  const handleTodayClick = () => {
    setRange({
      start: moment().format('YYYY-MM-DD'),
      end: moment().format('YYYY-MM-DD'),
    });
  };
  const handleYesterdayClick = () => {
    setRange({
      start: moment().subtract(1, 'day').format('YYYY-MM-DD'),
      end: moment().subtract(1, 'day').format('YYYY-MM-DD'),
    });
  };
  const handleLastWeekClick = () => {
    setRange({
      start: moment().subtract(1, 'week').startOf('week').format('YYYY-MM-DD'),
      end: moment().subtract(1, 'week').endOf('week').format('YYYY-MM-DD'),
    });
  };
  const handleLastMonthClick = () => {
    setRange({
      start: moment()
        .subtract(1, 'month')
        .startOf('month')
        .format('YYYY-MM-DD'),
      end: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
    });
  };
  const buttonText = useMemo(() => {
    let text = '';
    if (!range.start && !range.end) {
      text = 'Custom Date Range';
    } else {
      text = `${moment(range.start).format('DD MMM YYYY')} - ${moment(range.end).format('DD MMM YYYY')}`;
    }
    return text;
  }, [range.start, range.end]);
  return (
    <div className={styles.timePeriodsContainer}>
      <div
        className={classNames(styles.timePeriodItem, {
          [styles.timePeriodItem_selected]: isTodaySelected,
        })}
        onClick={handleTodayClick}
      >
        <Text
          variant={textVariantsEnum.Text_sm}
          fontWeight={fontWeightEnum.Medium}
        >
          Today
        </Text>
      </div>
      <div
        className={classNames(styles.timePeriodItem, {
          [styles.timePeriodItem_selected]: isYesterdaySelected,
        })}
        onClick={handleYesterdayClick}
      >
        <Text
          variant={textVariantsEnum.Text_sm}
          fontWeight={fontWeightEnum.Medium}
        >
          Yesterday
        </Text>
      </div>
      <div
        className={classNames(styles.timePeriodItem, {
          [styles.timePeriodItem_selected]: isLastWeekSelected,
        })}
        onClick={handleLastWeekClick}
      >
        <Text
          variant={textVariantsEnum.Text_sm}
          fontWeight={fontWeightEnum.Medium}
        >
          Last Week
        </Text>
      </div>
      <div
        className={classNames(styles.timePeriodItem, {
          [styles.timePeriodItem_selected]: isLastMonthSelected,
        })}
        onClick={handleLastMonthClick}
      >
        <Text
          variant={textVariantsEnum.Text_sm}
          fontWeight={fontWeightEnum.Medium}
        >
          Last month
        </Text>
      </div>
      <DateRangePicker
        startDate={moment(range.start)}
        endDate={moment(range.end)}
        onApply={(_event, { startDate, endDate }) => {
          setRange({
            start: startDate.format('YYYY-MM-DD'),
            end: endDate.format('YYYY-MM-DD'),
          });
        }}
      >
        <button
          type="button"
          className={classNames(styles.timePeriodItem, {
            [styles.timePeriodItem_selected]: isCustomDateRangeSelected,
          })}
        >
          {buttonText}
        </button>
      </DateRangePicker>
    </div>
  );
};
